/**
 * Interceptores globales de axios.
 *
 * - 401 (token inválido/expirado): limpia credenciales locales y redirige a /login UNA sola vez.
 *   Evita el patrón en el que un componente sigue polleando indefinidamente y spammea
 *   warnings de auth en los logs del backend (ej. PendingDebitsMonitor).
 * - 403 (sin permiso): NO redirige, solo deja que la pantalla maneje el caso (un super-admin
 *   route accedido por un merchant no debe expulsar al merchant de su sesión).
 *
 * Excluye rutas públicas (/api/public/...) y el propio login para no entrar en loops.
 */
import axios from 'axios';

let isHandlingUnauthorized = false;

const PUBLIC_PREFIXES = ['/api/public/', '/api/auth/login', '/api/auth/register'];

const isPublicRequest = (url = '') => PUBLIC_PREFIXES.some((p) => url.includes(p));

export function installAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || '';

      if (status === 401 && !isPublicRequest(url) && !isHandlingUnauthorized) {
        isHandlingUnauthorized = true;
        try {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('activeProjectId');
        } catch (e) {
          console.warn('[axiosClient] failed to clear localStorage:', e?.message || e);
        }
        // Solo redirigir si no estamos ya en /login
        if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
          window.location.replace('/login');
        }
      }
      return Promise.reject(error);
    },
  );
}
